import { apiClient } from "@/lib/apiClient";

export type CreateProvisioningPayload = {
  provisionId: string;
  stockId: string;
  provisionedAt: string;
  expiryDate?: string;
  purchaseDate?: string;
  label?: string;
  quantity: number;
  price: number;
  accountId: string;
};

export const PROVISIONINGS_KEY = "provisioning";

export const listProvisionings = async <T = unknown>(): Promise<T[]> => {
  const data = await apiClient.get<T[]>(PROVISIONINGS_KEY);
  return Array.isArray(data) ? data : [];
};

export const createProvisioning = <T = unknown>(payload: CreateProvisioningPayload): Promise<T> =>
  apiClient.post<T>(PROVISIONINGS_KEY, payload);

/** The backend accepts a whole batch on a single call. */
export const createProvisioningBatch = <T = unknown>(items: CreateProvisioningPayload[]): Promise<T> =>
  apiClient.post<T>("provisioning/batch", { items });
